import ArtigoPlaceholder from "@/components/feature/ArtigoPlaceholder";

export default function ArtigoCSSBuySneakers() {
  return (
    <ArtigoPlaceholder
      title="CSSBuy Sneakers Spreadsheet: O Guia Definitivo para Comprar Tênis da China"
      desc="Descubra como encontrar os melhores tênis importados da China usando as planilhas CSSBuy. Comparação de preços, qualidade e fornecedores confiáveis para Jordan, Nike, Yeezy e mais."
      icon="ri-footprint-line"
      slug="artigo-cssbuy-sneakers"
    />
  );
}